module.exports = __webpack_public_path__ + "static/media/keyan.0baf1dbe.png";